module.exports = __webpack_public_path__ + "img/img／被邀请人.65e873b7.png";